import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
@Component({
  selector: 'app-highlight-block',
  templateUrl: './highlight-block.component.html',
  styleUrls: ['./highlight-block.component.scss']
})
export class HighlightBlockComponent implements OnInit {
  @Input() block;
  @Input() index;
  @Input() listVariant;
  @Input() callToActionTitle;
  @Output() blockClick: EventEmitter<any> = new EventEmitter();
  constructor() {}

  ngOnInit() {}

  handleBlockClick(page) {
    if (window.location.hash.indexOf(page) > -1) {
      this.blockClick.emit(false);
    } else {
      window.location.hash = page;
      this.blockClick.emit(page);
    }
  }
}
